import { SiteName } from '@/scopes/common/domain/types'

// All environments use the same contextItemid for my booking page
const CONTEXT_ITEM_IDS: Partial<Record<SiteName, string>> = {
  sunwebnl: '1A5F526B-ADB0-4B31-99E8-B817C4163B33',
  sunwebbenl: '3BA2272D-50B4-4C7A-B860-C1011C4DC6C6',
  sunwebbefr: '67B2CACB-601E-44CF-9CDD-08C89B82AE71',
  sunwebde: '1327F2DF-545F-4DF7-BEA0-BB0EBA58BFD1', // test is not the same
  sunwebfr: 'B1DCBE86-4644-488E-BFE1-3B9C6EDE749B',
  sunwebdk: '79984687-721C-4B29-98B5-FAA8A800296A',
  sunwebse: 'BC588C55-2A5C-49D1-8D5B-D19C9F35AF75',
  sunwebuk: '4E59ECC6-A1F9-40C6-9470-C59976DEC5E7', // test is not the same
  elizanl: '2533D38D-21A8-4242-B72B-8DB3AF01561B',
  elizabe: 'BE006A29-22AB-4BB4-8C69-E96E85E733E4',
}

export function getContextItemId(siteName: SiteName): string {
  return CONTEXT_ITEM_IDS[siteName] || ''
}

export function appendContextItemId(url: string, contextItemId: string): string {
  if (!contextItemId)
    return url

  const separator = url.includes('?') ? '&' : '?'

  return `${url}${separator}contextitemid=${contextItemId}`
}
